<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="impuesto"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <div>

              <div class="w-full" 
                v-if="(role === 7 || role === 8 || role === 3) && !isIssuingCreation">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.entity_name')}}</label>
                <div class="flex justify-between">
                  <el-form-item prop="idCliente" class="w-full">
                    <base-el-select class="w-full" :options="clientes" v-model="form.idCliente" clearable filterable
                      :loading="loadingClientes" :disabled="!isCreate" />
                  </el-form-item>
                  <base-button v-if="!isCreate" class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading" type="button" />
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
                <el-form-item prop="Name">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Name"
                    maxlength='50'
                  />
                </el-form-item>
              </div>
            </div>

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('impuestos.TaxType')}}</label>
              <el-form-item prop="roleId">
                <base-el-select class="w-full" :options="tiposCodigoImpuesto" v-model="form.TaxType" clearable filterable :disabled="isIssuingCreation" />
              </el-form-item>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('impuestos.TaxRate')}}</label>
                <el-form-item prop="TaxRate">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.TaxRate"
                    type="number"
                    min="0" 
                    max="9999999999"
                  />
                </el-form-item>
              </div>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="isIssuingCreation ? $t('app.save_and_back') : $t('app.save') "
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'

import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getClients } from '@/services/clients/getClients'
import { getImpuesto } from '@/services/configurations/getImpuesto'
import { newImpuesto } from '@/services/configurations/newImpuesto'
import { createIRPF } from '@/services/configurations/createIRPF'
import { updateImpuesto } from '@/services/configurations/updateImpuesto'
import { DoubleUpToEightDecimalType } from '@/utils/regex'

import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  /* eslint-disable camelcase */
  name: 'impuesto-detail',
  components: {
    DetailLayout,
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      distribuidores: [],
      loadingDistribuidores: false,
      loadingClientes: false,
      header: {
        title: i18n.t('impuestos.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/impuestos',
        params: { issuingCreation: false }
      },
      loadedFirstTime: false,
      form: this.getDefaultForm(),
      clientes: [],
      rules: {
        idCliente: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        Name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        TaxType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        TaxRate: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isTaxRateValid, trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    id: function () {
      return this.$route.params.id
    },
    isClientFilterActive () {
      return this.$store.getters['impuestos/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    tiposCodigoImpuesto: function () {
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
  },
  created: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: x.idCliente }))
      this.loadingClientes = false
    }

    const breadcrumbs = []
    if (this.isIssuingCreation) {
      this.header.url = 'invoicesissuing'
      this.header.params.issuingCreation = true
      this.header.params.issuingType = this.issuingType
      const issuingBreadcrumb = {
        path: 'invoicesissuing',
        name: i18n.t('invoices.invoices_issuing.header_long'),
        params: { issuingCreation: true, issuingType: this.issuingType }
      }
      if (this.issuingType === 2) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.proforma.header_long')
      else if (this.issuingType === 3) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.quotation.header_long')
      breadcrumbs.push(issuingBreadcrumb)
    } else {
      breadcrumbs.push({
        path: 'masters',
        name: i18n.t('masters.header')
      })
      breadcrumbs.push({ path: 'masters/impuestos', name: i18n.t('impuestos.header') })
    }
    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.Name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.Name)
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('impuestos.new')
      })
      if (this.isIssuingCreation) {
        this.form.IdCliente = this.$route.params.idCliente
        this.form.TaxType = '04'
      } else if (this.actualFilterNav && this.isClientFilterActive) {
        this.form.idCliente = this.actualFilterNav.idCliente 
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    isTaxRateValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      const valueFloat = parseFloat(value)
      if (valueFloat < 0 || valueFloat > 100 || !DoubleUpToEightDecimalType.test(valueFloat)) {
        callback(new Error(i18n.t('validation.taxrate')))
      } else {
        callback()
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        Name: '',
        TaxType: '',
        TaxRate: '',
        idCliente: '',
      }
    },
    goDetailClient () {
      const id = this.form.idCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    watchFormHandler: function ({
      certificate,
      send_alerts
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.isIssuingCreation ? this.newIRPFEmisionHandler(formName) : this.newImpuestoHandler(formName)
      } else {
        this.updateImpuestoHandler(formName)
      }
    },
    newImpuestoHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            Nombre: this.form.Name,
            Name: this.form.Name,
            TaxType: this.form.TaxType,
            TaxRate: this.form.TaxRate,
            idCliente: this.form.idCliente,
          }
          const response = await newImpuesto(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.goBack()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    newIRPFEmisionHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            TaxType: '04',
            idCliente: this.form.IdCliente,
            idImpuesto: null,
            Name: this.form.Name,
            TaxRate: parseFloat(this.form.TaxRate)
          }
          const response = await createIRPF(params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.goEmission()
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateImpuestoHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {
            idImpuesto: this.form.id,
            Name: this.form.Name,
            TaxType: this.form.TaxType,
            TaxRate: this.form.TaxRate,
          }
          const response = await updateImpuesto(params)
          if (response.blnError === false) {
            this.$message({
              type: 'success',
              message: i18n.t('feedback.success.saved_data_msg')
            })
            this.updateView()
          } else {
            this.$message({
              type: 'error',
              message: response.msgError
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedback.error.process_data_error')
          })
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (!this.isIssuingCreation) {
        this.$router.push({ name: 'masters/impuestos' })
      } else {
        this.goEmission()
      }
    },
    goEmission () {
      setTransitionAllowed(1, true)
      this.$router.push({ 
        name: 'invoicesissuing',
        params: { issuingCreation: true, issuingType: this.issuingType }
      })
    },
    downloadData: async function (id) {
      let res = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idImpuesto: id
        }
        res = await getImpuesto(params)
        this.setRes(res.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return res
    },
    setRes: function (res) {
      this.form.id = res.idImpuesto
      this.form.Name = res.Name
      this.form.TaxType = res.TaxType
      this.form.TaxRate = res.TaxRate
      this.form.idCliente = res.idCliente
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.Name
      this.$store.commit('app/setheaderBreadCrumb', this.form.Name)
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
